import { gql } from '@apollo/client';

const Fragments = {
  requiredDocumentItem: gql`
    fragment requiredDocumentItem on RequiredDocumentItem {
      requiredDocTypeId
      documentName
      documentCode
      sharePointContentType
    }
  `
};
export default Fragments;
